import { resolveSafeLogoutRedirect } from './federatedLogoutUtils'
import { clearLocalStorage, getAllowedTenantEnterpriseType } from './utility'

export const readTenantEnterpriseConnectionIds = () => {
  try {
    const raw = localStorage.getItem('connection_id')
    if (!raw) return {}

    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch (error) {
    console.error('Error reading connection_id from localStorage:', error)
    return {}
  }
}

export const resolveFederatedLogoutUrl = (orgId, tenantEnterpriseConnectionIds = {}) =>
  tenantEnterpriseConnectionIds?.[orgId]?.logout_url ||
  tenantEnterpriseConnectionIds?.all?.logout_url ||
  null

/**
 * Signs the current user out the same way the user menu does: clears local storage, then
 * sends JIT SSO users through their tenant's federated logout URL when one is configured.
 *
 * @param {object} params
 * @param {object} params.clerk Clerk instance from `useClerk()`.
 * @param {object} [params.user] Clerk user from `useUser()`.
 * @returns {Promise<boolean>} `true` when Clerk sign-out completed; `false` on failure.
 */
export const signOutCurrentUser = async ({ clerk, user }) => {
  try {
    const orgId = clerk?.organization?.id
    const tenantEnterpriseConnectionIds = readTenantEnterpriseConnectionIds()
    const allowedTenantEnterpriseType = getAllowedTenantEnterpriseType(
      orgId,
      user?.enterpriseAccounts?.[0]?.enterpriseConnectionId,
      tenantEnterpriseConnectionIds,
    )

    clearLocalStorage()

    if (allowedTenantEnterpriseType === 'jit') {
      const logoutUrl = resolveFederatedLogoutUrl(orgId, tenantEnterpriseConnectionIds)
      const safeLogoutUrl = resolveSafeLogoutRedirect(logoutUrl)
      if (safeLogoutUrl) {
        await clerk.signOut({ redirectUrl: safeLogoutUrl })
        return true
      }
    }

    await clerk.signOut({ redirectUrl: '/' })
    return true
  } catch (error) {
    console.error('Error signing out:', error)
    return false
  }
}
